import { brand } from '@/brand/brand';
import { routes } from '@/routes/routes';

export const fallbackData = {
  pageHeader: {
    slug: 'USING FALLBACK DATA',
    modelId: 'pageHeader',
    title: `My ${brand.brandChainName} Licenses`,
    primaryButton: {
      slug: 'USING FALLBACK DATA',
      title: 'Buy Licenses',
      url: routes.store.path,
    },
    secondaryButton: {
      slug: 'USING FALLBACK DATA',
      title: 'Set Up My Wallet',
      url: routes.setupWallet.path,
    },
  },
  smartNodeCard: {
    slug: 'USING FALLBACK DATA',
    title: 'Smart Nodes',
    subTitle: 'Active',
    toolTip: {
      slug: 'USING FALLBACK DATA',
      title: 'What are Smart Nodes?',
      helpText:
        'A Smart Node license gives the Node owner the highest opportunity to receive rewards. When you buy a Node license, you can install and run it on your personal computer or VPS. These Nodes are much more expensive. A personal computer can run one Smart Node.',
    },
  },
  liteNodeCard: {
    slug: 'USING FALLBACK DATA',
    title: 'Lite Nodes',
    subTitle: 'Active',
    toolTip: {
      slug: 'USING FALLBACK DATA',
      title: 'What are Lite Nodes?',
      helpText:
        'A Lite Node performs similar tasks to a Smart Node but is much more user-friendly. A Lite Node license earns smaller rewards but is much less expensive than Smart Nodes. One computer or VPS can run up to 100 Lite Node.',
    },
  },
  nodeSetupCard: {
    slug: 'USING FALLBACK DATA',
    title: 'Node Setup',
    subTitle: 'Easiest',
    description:
      'You have a FREE licensed node awaiting activation. Choose the operating system below that you would like to set up your node on, and start earning rewards.',
    image: brand.fallbackImages.nodeBanner,
    platforms: [
      {
        slug: 'USING FALLBACK DATA',
        title: 'Block Fabric',
        url: brand.blockFabricUrl,
        icon: brand.fallbackImages.blockFabricHash,
        iconAlt: brand.fallbackImages.blockFabric,
      },
      {
        slug: 'USING FALLBACK DATA',
        title: routes.vps.value,
        url: routes.vps.path,
        icon: routes.vps.icon,
      },
      {
        slug: 'USING FALLBACK DATA',
        title: routes.mac.value,
        url: routes.mac.path,
        icon: routes.mac.icon,
      },
      {
        slug: 'USING FALLBACK DATA',
        title: routes.linux.value,
        url: routes.linux.path,
        icon: routes.linux.icon,
      },
    ],
  },
};

export const supportLinks = {
  green: {
    vps: 'https://support.setpowerfree.com/hc/en-us/articles/4406686882579-What-is-a-VPS',
    mac: 'https://support.setpowerfree.com/hc/en-us/articles/26072485893651-How-do-I-run-my-Smart-Node-or-Lite-Node-using-the-Node-Software-on-my-device',
    linux:
      'https://support.setpowerfree.com/hc/en-us/articles/32919145313683-How-do-I-Install-my-node-using-Linux-Ubuntu',
  },
  galvan: {
    vps: 'https://support.galvan.health/hc/en-us/articles/26913629035035-How-to-check-the-status-of-my-node-set-up-on-Vultr-VPS',
    mac: 'https://support.galvan.health/hc/en-us/articles/20234383457307-How-to-Install-my-Node-Software-on-a-Mac',
    linux:
      'https://support.galvan.health/hc/en-us/articles/20234495495707-How-do-I-Install-my-node-using-Linux-Ubuntu',
  },
  grow: {
    vps: 'https://support.connectunited.com/hc/en-us/articles/4561289616667-VULTR-VPS-Setup',
    mac: 'https://support.connectunited.com/hc/en-us/articles/22584973269915-Software-Download-for-Mac-and-Linux',
    linux:
      'https://support.connectunited.com/hc/en-us/articles/22584973269915-Software-Download-for-Mac-and-Linux',
  },
  element: {
    vps: 'https://support.elementunited.com/hc/en-us/articles/13500333027739-How-do-I-set-up-my-node-on-Digital-Ocean-VPS-provider',
    mac: 'https://support.elementunited.com/hc/en-us/articles/15339989038619-How-do-I-host-an-Element-node-on-my-personal-computer-MAC',
    linux:
      'https://support.elementunited.com/hc/en-us/articles/22574480118939-How-do-I-set-up-my-node-on-Linux-Ubuntu',
  },
  elevate: {
    vps: 'https://support.elevateunited.com/hc/en-us/articles/27073198747547-What-codes-are-needed-to-set-up-a-VPS',
    mac: 'https://support.elevateunited.com/hc/en-us/articles/19269945229339-How-do-I-host-an-Elevate-node-on-my-personal-computer-MAC',
    linux:
      'https://support.elevateunited.com/hc/en-us/articles/27071681007771-How-do-I-set-up-my-node-on-Linux-Ubuntu',
  },
  liberty: {
    vps: 'https://support.libertyblockchain.com/hc/en-us/articles/17731859933197-How-do-I-run-my-Liberty-Smart-Node-on-Vultr',
    mac: 'https://support.libertyblockchain.com/hc/en-us/articles/17687728726797-How-to-run-my-Liberty-Node-on-my-computer-MacOS',
    linux: '',
  },
  hyper: {
    vps: '',
    mac: '',
    linux: '',
  },
  switch: {
    vps: 'https://support.switchrewardcard.com/hc/en-us/articles/4527141143067-How-do-I-install-my-Node-on-a-VPS',
    mac: 'https://support.switchrewardcard.com/hc/en-us/articles/5181199073051-How-do-I-set-up-my-Lite-Node-or-Smart-Node-using-the-Switch-Node-Software',
    linux:
      'https://support.switchrewardcard.com/hc/en-us/articles/5181199073051-How-do-I-set-up-my-Lite-Node-or-Smart-Node-using-the-Switch-Node-Software',
  },
  revo: {
    vps: 'https://help.revoride.com/hc/en-us/articles/29836044156051-How-do-I-set-up-a-node-through-a-VPS',
    mac: 'https://help.revoride.com/hc/en-us/articles/30898849353619-How-do-I-host-a-Rev-node-on-my-personal-computer-MacOS',
    linux:
      'https://help.revoride.com/hc/en-us/articles/30899021510419-How-do-I-set-up-my-node-on-Linux-Ubuntu',
  },
  'r-link': {
    vps: 'https://help.r-link.com/hc/en-us/articles/29890689653140-How-do-I-set-up-a-node-through-a-VPS',
    mac: 'https://help.r-link.com/hc/en-us/articles/29891696868628-How-do-I-host-an-R-link-node-on-my-personal-computer-MacOS',
    linux:
      'https://help.r-link.com/hc/en-us/articles/29934296704788-How-do-I-Install-my-node-using-Linux-Ubuntu',
  },
};

export const getSupportLinks = (brandName) => {
  const normalizedBrandName = brandName.toLowerCase();
  return supportLinks[normalizedBrandName] || { vps: '', mac: '', linux: '' };
};
